module.exports = __webpack_public_path__ + "static/feature-window-02-6d728a5bac15629e90f2e7e12eee5d41.png";